export default __webpack_public_path__ + "images/9d07f97d92408f907729940545c12546-truemed-logo.svg";